export default function billTotal(inv_total, shipping, inv_discount, customer_discount, spent, rate) {
  let calculatedDiscount = (inv_total * customer_discount) / 100;
  let discount = inv_discount !== 0 ? inv_discount : calculatedDiscount;
  let subtotal = inv_total + shipping - discount - spent;
  let taxRate = rate;
  let total = subtotal + (subtotal * taxRate);
  return Math.round(total * 100) / 100;
}